<template>
<!-- 发送站内消息弹窗 -->
  <el-dialog
    :visible="visibleInside"
    width="400px"
    title="发送站内信息"
    @close="$emit('close')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="formData"
      label-width="100px"
      :rules="rules"
      ref="messageAddForm"
    >
      <el-form-item prop="user_id" label="用户ID：">
        <el-input
          type="text"
          placeholder="请输入用户ID"
          v-model="formData.user_id"
        ></el-input>
      </el-form-item>
      <el-form-item prop="content" label="消息内容：">
        <el-input
          type="textarea"
          placeholder="请输入消息内容"
          :rows="3"
          v-model="formData.content"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="$emit('close')">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="submit"
        :loading="buttonLoading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { postData, patchData } from '../../../http'
export default {
  data() {
    return {
      buttonLoading: false,
      formData: {
        user_id: '',
        content: '',
      },
      rules: {
        user_id: [
          {
            required: true,
            message: '用户id不能为空'
          }
        ],
        content: [
          {
            required: true,
            message: '消息内容不能为空'
          }
        ]
      }
    }
  },
  props: {
    visible: Boolean,
  },
  computed: {
    visibleInside: {
      get() {
        return this.visible
      },
      set() { }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        if (this.$refs['messageAddForm']) {
          this.$refs['messageAddForm'].resetFields()
        }
      }
    },
  },
  methods: {
    submit() {
      this.$refs['messageAddForm'].validate(valid => {
        if (valid) {
          this.buttonLoading = true
          postData('send_news', this.formData)
            .then(
              () => {
                this.$message.success('添加成功')
                this.$emit('close')
              }
            )
            .finally(() => {
              this.buttonLoading = false
            })
        }
      })
    }
  }
}
</script>
